export class BaseClient {
  constructor(instance) {
    this.axiosInstance = instance
  }

  createRequest(requestConfig) {
    return async (requestData = {}, signal) => {
      try {
        const response = await this.axiosInstance.request({
          ...requestConfig,
          ...requestData,
          ...(signal && { signal }),
        })

        return response.data
      } catch (error) {
        throw { data: error?.response?.data, response: error?.response }
      }
    }
  }
}
